/*
  Move garment position app
  implemented: layout/theme.liquid, snippets/product-block-buy-buttons.liquid
*/
 document.addEventListener("DOMContentLoaded", function () {
     //alert('loaded')

     function whenAvailable(DOM_element, callback) {
      const zeptoEl = document.querySelector(DOM_element)
      const interval = 1000; 
       
      const int = window.setTimeout(function() {
          if (zeptoEl) {
              callback(zeptoEl);
              clearInterval(int)
          } else {
              whenAvailable(DOM_element, callback);
          }
      }, interval);
    }
   

   whenAvailable("king-linked-options-product", function(el) {
     console.log("Garment app loaded", el)
     
     const container = document.querySelector('[data-js-garment-position]');
     const mystery_box_container = document.querySelector('[data-js-mystery-garment-position]');
     
     const mystery_box_tshirt = document.querySelector('form input[value="6545420615816"]')
     const mystery_box_sweatshirt = document.querySelector('form input[value="8417293402248"]')
     const mystery_box_hoodie = document.querySelector('form input[value="8417293467784"]')

     mystery_box_tshirt || mystery_box_sweatshirt || mystery_box_hoodie ? mystery_box_container?.appendChild(el) : container?.appendChild(el)
     el.classList.add('loaded')

  });
   
 })
